import React, { useEffect } from 'react';
import '../css/myeKukka.css';
import Header from "../components/header/Header"
import Footer from "../components/footer/Footer"
import landing_img from '../images/landing.jpg';
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft} from '@fortawesome/free-solid-svg-icons'
import JoinUs from "../components/JoinUs"
import $ from 'jquery';
//import { useSearchParams } from "react-router-dom";

const MyeKukka = props => {
  useEffect(() => {
    controlHistory()
    $('body').css('background', '#fff');
  }, [])


  //const [searchParams, setSearchParams] = useSearchParams();
  const queryParameters = new URLSearchParams(window.location.search)
  const navigate = useNavigate();
  function controlHistory() {
    window.onpopstate = function (event) {
      var page = 'signIn';
      if (document.location.hash.substring(1) !== '') {
        page = document.location.hash.substring(1);
      }
    }
  }
  const navigateSignIn = () => {
    if (queryParameters.get("ref") === 'shop'){
      props.backToShop()
      return;
    }
    navigate('/#signIn');
  };

  /*
  const navigateSignUp = () => {
    navigate('/#signUp');
  };
  */


  const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let clientId = "4inkkk5uo5ef4foec6enqofo0v";
  let lastAuthUser = getCookie("CognitoIdentityServiceProvider."+ clientId +".LastAuthUser");
  let user = getCookie("CognitoIdentityServiceProvider."+ clientId +"."+ lastAuthUser +".userData");

  return(
    <div>
      <Header/>
        <div className="header_nav_container">
          <div className="go_back_div" onClick={navigateSignIn}><FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" /> <span className="textUnderline">Palaa takaisin</span></div>
          { user !== "" || user !== "undefined" && <div className="signIn_link_text"><span id="already_user">Oletko jo jäsen?</span> <span className="sign_link" onClick={navigateSignIn}>Kirjaudu sisään</span></div>}
        </div>
        <div className="page_container">
          <div className="section platform_membership">
            <h2 className="top_header">Oma eKukka -jäsenyys</h2>
            <strong>Kenelle Oma eKukka on tarkoitettu?</strong>
            <p>Oma eKukka on tarkoitettu juuri Sinulle!</p>
            <p>Tilaapa sitten satunnaisesti tai useammin, hyödyt Oma eKukasta.</p>

            <p>Oma eKukka ei maksa mitään ja liittyminen vie vain hetken.</p>

            <img className="platform_membership_img" src={landing_img} alt="platform"/>
          </div>
          <div className="section platform_advantages">
              <div className="platform_advantages_content">
                <h2 className="header">Oma eKukan edut</h2>
                <ol>
                  <li>Nopeuta kukkien tilaamista tallentamalla omat yhteystietosi.</li>
                  <li>Säilytä ostoskorin sisältö, vaikka vaihdat laitetta.</li>
                  <li>Seuraa tilauksesi valmistumista.</li>
                  <li>Löydä helposti aiemmat tilauksesi ja niiden kuitit.</li>
                  <li>Inspiroidu ammattilaisten kukkavinkeistä ja koeta onneasi osallistumalla arvontoihin.</li>
                </ol>
              </div>
          </div>
        </div>

        <JoinUs/>

      <Footer/>
    </div>
  )
}
export default MyeKukka;
